import { User } from './../../models/user.model';
import { Observable } from 'rxjs';
import { Router } from '@angular/router';
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ToastrService } from 'ngx-toastr';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class AuthsiteService {
  baseUrlSite = environment.baseUrlSite;

  constructor(
    private http: HttpClient,
    private router: Router,
    private toastr: ToastrService
  ) {}

  public login(token): Observable<any> {
    const service = 'login';
    return this.http.post<any>(this.baseUrlSite + service, { token });
  }

  public loggedIn() {
    return !!localStorage.getItem('token');
  }

  public logout() {
    localStorage.removeItem('token');
    localStorage.removeItem('email');
    this.toastSuccess('Logout efetuado com sucesso !');
    window.location.href = 'https://move.pecege.com/'
  }

  public profile(): Observable<any> {
    const service = 'profile';
    return this.http.get<any>(this.baseUrlSite + service);
  }

  public getToken() {
    return localStorage.getItem('token');
  }

  public update(user: any): Observable<User> {
    const service = "profile/edit";
    return this.http.put<User>(this.baseUrlSite + service, user);
  }

  public toastSuccess(msg: string) {
    return this.toastr.success(msg);
  }

  public toastError(msg: string) {
    return this.toastr.error(msg);
  }
}
